// TnL: 34742
export const isPriceSliderFilter = (min: number, max: number): boolean =>
  min !== null && min !== undefined && max !== null && max !== undefined;
